module.exports = __webpack_public_path__ + "img/know.a3e259e9.png";